import type { AddLineItemType } from "@/Shared/Types/lineItemTypes";
import type { SavedCommodity } from "@freightsimple/generated-dashboard-openapi-client/models/SavedCommodity";
import { HandlingUnitType } from "@freightsimple/generated-dashboard-openapi-client/models/HandlingUnitType";
import { TemperatureHandling } from "@freightsimple/generated-dashboard-openapi-client/models/TemperatureHandling";
import { v4 as uuidv4 } from "uuid";

export function lineItemsEmpty(): AddLineItemType {
  return {
    lineItemId: uuidv4(),
    numberHandlingUnits: 1,
    temperatureHandling: TemperatureHandling.NoSpecialHandling,
    isStackable: false,
    isDangerous: false,
    handlingUnitType: HandlingUnitType.Pallet,
  };
}

export function lineItemFromSavedCommodity(
  sc: SavedCommodity,
): AddLineItemType {
  return {
    lineItemId: uuidv4(),
    numberHandlingUnits: 1,
    nmfcItemNumber: sc.nmfcItemNumber,
    temperatureHandling: sc.temperatureHandling,
    isStackable: sc.isStackable,
    isDangerous: sc.isDangerous,
    handlingUnitType: sc.handlingUnitType,
    dangerousUnNumber: sc.dangerousUnNumber,
    dangerousClassification: sc.dangerousClassification,
    dangerousPackingGroup: sc.dangerousPackingGroup,
    dangerousProperShippingName: sc.dangerousProperShippingName,
    dangerousTechnicalName: sc.dangerousTechnicalName,
    dangerousNumberPackages: sc.dangerousNumberPackages,
    dangerousPackagingType: sc.dangerousPackagingType,
    description: sc.description,
    length: sc.lengthInches,
    width: sc.widthInches,
    height: sc.heightInches,
  };
}
